import { useSession } from 'next-auth/react'
import useSWR from 'swr'
import { UserEventFavoriteRead } from 'domain/models/User/UserEventFavoriteRead'
import { apiClient } from 'services/api/client'

export const useGetUserEventFavorites = () => {
  const session = useSession()

  return useSWR(
    session.status !== 'authenticated' ? null : 'user-event-favorites',
    () => apiClient.get<UserEventFavoriteRead[]>('/user-event-favorite')
  )
}
